import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataCurrenciesActions } from "./currencies.actions";

// **************************************************************************
// CURRENCIES REDUCER
// **************************************************************************

const load = on(DataCurrenciesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        currency: {
            ...state.data.currency,
            currenciesLoading: true,
        },
    },
}));

const loadSuccess = on(DataCurrenciesActions.loadSuccess, (state: ApplicationStore, { currencies }) => ({
    ...state,
    data: {
        ...state.data,
        currency: {
            ...state.data.currency,
            currencies,
            currenciesLoading: false,
        },
    },
}));

const loadFailure = on(DataCurrenciesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        currency: {
            ...state.data.currency,
            currenciesLoading: false,
        },
    },
}));

export const currenciesReducer = [load, loadSuccess, loadFailure];
